export default "__VITE_ASSET__CgmYEfH5__"